import { User } from "../../../../services/UsersService";
import QueryParamFinder from "./queryParamFinder/QueryParamFinder";

export type CustomerSuccessTabProps = {
  readonly user: User;
};

const CustomerSuccessTab = ({ user }: CustomerSuccessTabProps) => (
  <div>
    <h2 className="mb-4">Customer Success tools</h2>
    <QueryParamFinder user={user} />
  </div>
);

export default CustomerSuccessTab;
